
import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { useGlobalContext } from "../../context";
import CloseIcon from '@mui/icons-material/Close';

function SubmitPopup({
                 submitPost,
                 caption,
                 files,
                 checkinClients,
                 activeCategory,
                 dateTime,
                 scheduleCategoryType,
                 location
                }) {
    const {
        openSubmitPopup,
        setOpenSubmitPopup
    } = useGlobalContext();

    const [showImages, setShowImages] = useState([]);

    const showFiles = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    resolve(reader.result);
                }
            };
            reader.onerror = () => {
                reject(new Error("Failed to read file"));
            };
            reader.readAsDataURL(file);
        });
    };

    const handleFile = async () => {
        for(let i = 0; i < files.length; i++) {
            const fileUrl = await showFiles(files[i]);
            if (fileUrl) setShowImages(showImages => { return [...showImages, fileUrl]});
        }
    };

    useEffect(() => {
        if (showImages.length === 0 && openSubmitPopup) handleFile();
    }, [files, openSubmitPopup]);

    return(
        <ReactModal
            isOpen = { openSubmitPopup }
            onRequestClose = {() => {
                setShowImages([]);
                setOpenSubmitPopup(false);
            }}
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 300,
                },
                content: {
                    width: "90%",
                    top: "5px",
                    maxWidth: '630px',
                    maxHeight: "500px",
                    height: "85vh",
                    border: 'none',
                    margin: "auto",
                    left: "5%",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                }
            }}
        >
            <div
                style = {{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                }}
            >
                <CloseIcon
                    style = {{
                        cursor: "pointer",
                    }}
                    onClick = {() => {
                        setShowImages([]);
                        setOpenSubmitPopup(false);
                    }}
                />
            </div>
            <div className = "popupMainBox">
                <h3
                    style = {{
                        fontSize: "26px",
                        color: "rgb(63, 104, 177)",
                        fontWeight: "700",
                        fontFamily: "Verdana",
                        textAlign: "center",
                        margin: "15px 0"
                    }}
                >
                    Do You Want to Submit This Post ?
                </h3>
                <div className="popupSubmitData">
                    <span className="popupSubmitHeadText">Caption</span>
                    <span className="popupSubmitDotsText"> : </span>
                    <span className="popupSubmitDataText">{ caption }</span>
                </div>

                <div className="popupSubmitData">
                    <span className="popupSubmitHeadText">Clients</span>
                    <span className="popupSubmitDotsText"> : </span>
                    <span className="popupSubmitDataText">{ checkinClients.length }</span>
                </div>
                {
                    location.pathname === "/add-post" ?
                        <div className="popupSubmitData">
                            <span className="popupSubmitHeadText">Category</span>
                            <span className="popupSubmitDotsText"> : </span>
                            <span className="popupSubmitDataText">{ activeCategory?.toLowerCase() }</span>
                        </div>
                    : null
                }
                {
                    location.pathname === "/schedule-post" ?
                        <>
                            <div className="popupSubmitData">
                                <span className="popupSubmitHeadText">Select By</span>
                                <span className="popupSubmitDotsText"> : </span>
                                <span className="popupSubmitDataText">{ scheduleCategoryType?.text }</span>
                            </div>
                            {
                                scheduleCategoryType?.text === "Category" ?
                                    <div className="popupSubmitData">
                                        <span className="popupSubmitHeadText">Category</span>
                                        <span className="popupSubmitDotsText"> : </span>
                                        <span className="popupSubmitDataText">{ activeCategory?.toLowerCase() }</span>
                                    </div>
                                    : null
                            }
                            <div className="popupSubmitData">
                                <span className="popupSubmitHeadText">Date And Time</span>
                                <span className="popupSubmitDotsText"> : </span>
                                <span className="popupSubmitDataText">{ dateTime?.$d.toLocaleString("en-US") }</span>
                            </div>
                        </>
                        :
                        null
                }
                <div className="popupSubmitData">
                    <span className="popupSubmitHeadText">Files</span>
                    <span className="popupSubmitDotsText"> : </span>
                    <span className="popupSubmitDataText">
                        {
                            showImages?.map(item => <img src = { item } className="popupSubmitDataImg" alt=""/>)
                        }
                    </span>
                </div>
            </div>
            <div className="popupSubmitBtnBox">
                <button
                    className = "popupSubmitBtn"
                    onClick = { submitPost }
                >
                    POST
                </button>
            </div>
        </ReactModal>
    )
}

export default SubmitPopup

